export default "__VITE_ASSET__Uitn_pHg__";